import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=0dc4f8a2&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=0dc4f8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc4f8a2",
  null
  
)

export default component.exports